import React from 'react';
import { CheckIcon } from 'lucide-react';
const NUMBERS = [{
  value: '6',
  label: 'Complete Modules'
}, {
  value: '5',
  label: 'Strategic Bonuses'
}, {
  value: 'All',
  label: 'Experience Levels'
}, {
  value: 'Full',
  label: 'Teaching Coverage'
}];
const COVERAGE = ['Ready-To-Teach Classes', 'Professional Sequences', 'Class Building', 'Pose Guidance', 'Student Progression', 'Teaching Cues', 'Planning Resources', 'Studio, Private & Online'];
export function SystemOverview() {
  return <section aria-labelledby="system-title" className="w-full bg-ivory px-4 py-10 sm:px-6" data-id="element-214" data-mp="pxga6dltxuy2">
      <div className="mx-auto max-w-5xl text-center" data-id="element-215" data-mp="13wfvpce1ptq0">
        <span className="font-head text-[11px] font-bold uppercase tracking-wider text-brand sm:text-xs" data-id="element-216" data-mp="13ttfkod3a5w6">
          The complete system to stop improvising your classes
        </span>
        <h2 id="system-title" className="mt-2 font-head text-3xl font-extrabold uppercase text-charcoal sm:text-4xl" data-id="element-217" data-mp="2f9i4vmdtfh05">
          Yoga Teaching Vault™
        </h2>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-snug text-softgray sm:text-base" data-id="element-218" data-mp="235up7jflftd9">
          Ready-to-teach classes, professional sequences, class-building tools, pose guidance,
          student resources, and instructor templates. Everything organized and ready when you need
          it.
        </p>

        <dl className="mt-6 grid grid-cols-2 gap-2 lg:grid-cols-4" data-id="element-219" data-mp="2i1k99c17xwfc">
          {NUMBERS.map(item => <div key={item.label} className="rounded-2xl border border-brand/15 bg-white px-2 py-4 text-center" data-id="element-220" data-mp="1ke1tvid1xw2d">
              <dd className="font-head text-2xl font-extrabold uppercase text-brand sm:text-3xl" data-id="element-221" data-mp="1udairwt28khv">
                {item.value}
              </dd>
              <dt className="mt-0.5 font-head text-[10px] font-semibold uppercase tracking-wide text-softgray sm:text-xs" data-id="element-222" data-mp="1z6lvgekjzvhp">
                {item.label}
              </dt>
            </div>)}
        </dl>

        <p className="mt-8 font-head text-sm font-bold uppercase tracking-wide text-charcoal sm:text-base" data-id="element-223" data-mp="ynilmsp1ynxt">
          Complete coverage for every teaching need
        </p>
        <ul className="mt-3 grid grid-cols-2 gap-2 text-left lg:grid-cols-4" data-id="element-224" data-mp="tmmgycwvmxrc">
          {COVERAGE.map(item => <li key={item} className="flex items-center gap-2 rounded-xl border border-sage/25 bg-sage/5 px-3 py-2 text-xs font-medium leading-snug text-charcoal sm:text-sm" data-id="element-225" data-mp="13eiglsem2vxo">
              <CheckIcon className="h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-226" data-mp="aqcvv5nk56xu" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}